import { connect } from 'react-redux'
import config from '../../config.json'
import { requestAuthLogoutWP } from '../../actions'

const mapDispatchToProps = dispatch => ({
    doLogout: () => dispatch(requestAuthLogoutWP())
})

const Logout = ({doLogout}) => (
    <nav className="user-nav">
        <ul>
            <li className={'logout'}>
                <div className="link" onClick={doLogout}>
                    <span className="navigation-submenu">{config.routes.logout.name}</span>
                </div>
            </li>
        </ul>
    </nav>
)

export default connect(null, mapDispatchToProps)(Logout)